import React from 'react';
import { Layout } from '../../../core/components/Layout/component.js';
import { DismissAction } from './dismiss-action.js';

var WrappedCardContainer = function WrappedCardContainer(_ref) {
  var dismissable = _ref.dismissable,
      onDismiss = _ref.onDismiss,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(DismissAction, {
    dismissable: dismissable,
    onDismiss: onDismiss
  }), children);
};

WrappedCardContainer.displayName = "WrappedCardContainer";
export { WrappedCardContainer };